import { combineReducers } from 'redux';
import modals from "./modals";
import manage from "./manage";
import alert from "./alert";
import page from "./page";
import home from "./page";
import classdata from "./classdata";
import rankingList from "./rankingList";
import studentinfo from "./studentinfo";
import activityList from "./activityList";
import activityDetail from "./activityDetail";
import dongtaiDetail from "./dongtaiDetail";
import versionUpdate from "./versionUpdate";
import zipingList from "./zipingList";
import activityShenhe from "./activityShenhe";
import termreport from './termreport'

const reducers = combineReducers({
    modals,
    manage,
    alert,
    page,
    home,
    classdata,
    rankingList,
    studentinfo,
    activityList,
    activityDetail,
    dongtaiDetail,
    versionUpdate,
    zipingList,
    activityShenhe,
    termreport
})

export default reducers
